import type { AppShellNavSection } from '@avila-roffe/components-web';
import { ChefHat, LayoutDashboard, Settings, UsersRound, UtensilsCrossed } from 'lucide-react';

export const STATIC_NAV: AppShellNavSection[] = [
  {
    items: [
      { label: 'Dashboard', href: '/dashboard', icon: LayoutDashboard },
      { label: 'Restaurants', href: '/restaurants', icon: UtensilsCrossed },
      {
        label: 'Food',
        icon: ChefHat,
        items: [
          { label: 'Plates Library', href: '/plates' },
          { label: 'Beverage List', href: '/beverages' },
          { label: 'Customizations', href: '/customisations' },
          { label: 'Menus', href: '/menus' },
        ],
      },
      { label: 'Waiters', href: '/waiters', icon: UsersRound },
    ],
  },
  {
    label: 'Settings',
    items: [{ label: 'Settings', href: '/settings', icon: Settings }],
  },
];
